export default __webpack_public_path__ + "static/media/kitchen3-afterI-768w.61b763e0.avif";